import { useState } from "react";

type Props<T> = {
  paginate: () => void;
  list?: T[];
};

// A hook for getting the correct auto focus index when paginating, so the first new result gets tab focus
export const usePaginateAndFocusIndex = <T>({ paginate, list }: Props<T>) => {
  const [autoFocusIndex, setAutoFocusIndex] = useState<number | undefined>(undefined);
  const paginateAndFocus = () => {
    //sets focus on first item of next pagination
    setAutoFocusIndex(list?.length);
    paginate();
  };

  return { paginateAndFocus, autoFocusIndex };
};
